'use es6';
/**
 * @enum {String}
 * @readonly
 */

export const STRUCTURAL_WIDGET = 'STRUCTURAL_WIDGET';
export const CUSTOM_WIDGET = 'CUSTOM_WIDGET';
export const GLOBAL_GROUP = 'GLOBAL_GROUP';
export const GLOBAL_WIDGET = 'GLOBAL_WIDGET';
export const DEFAULT_WIDGET = 'DEFAULT_WIDGET';
export const THEME_WIDGET = 'THEME_WIDGET';